module.exports = __webpack_public_path__ + "img/direction-right.18909693.svg";